module.exports = __webpack_public_path__ + "static/media/skägg-min.050b03c7.png";